<template>
    <a-modal v-model="visible" :title="link" @cancel="$emit('close')" :style="!loading && 'top: 10px;'" width="90%" :zIndex="10000">
      <div class="py-5 text-center" v-if="loading">
          <hollow-dots-spinner
              :animation-duration="1000"
              :dot-size="15"
              :dots-num="5"
              color="#20409a"
              class="mx-auto"
          />
          <br />
          <h4>Loading up {{ link }}...</h4>
          <p>This site will load up according to your internet speed</p>
      </div>

      <iframe :src="'http://'+link" width="100%" height="490px" @load="onLoad" :style="loading && 'display: none;'">
        <p>Your browser does not support iframes.</p>
      </iframe>

      <template slot="footer">
        <a-button key="back" @click="$emit('close')">
          Close
        </a-button>
        <a-button class="btn btn-primary" @click="openLink">
          Visit
        </a-button>
      </template>
    </a-modal>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners';

export default {
  components: {
    HollowDotsSpinner,
  },
  props: {
    visible: Boolean,
    link: String,
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    openLink() {
      window.open('http://'+this.link, '_blank');
    },
    onLoad() {
      this.loading = false;
    }
  },
}
</script>

<style>

</style>